import React from "react";
import { Link } from "react-router-dom";
import LayoutStyle from "../../src/style/layouts/LoginLayout.module.css";
import PagesStyle from "../style/Main.module.css";
import authStyle from "../style/layouts/auth.module.css";
const AuthLayout = ({ image, subtitle, children, footerLinks, logo }) => {
  return (
    <div className={LayoutStyle.loginContainer}>
      <div className={LayoutStyle.loginContainerChild}>
        <div className={LayoutStyle.loginImage}>
          <div className={LayoutStyle.loginImageContent}>
            <img src={image} alt="Auth" />
          </div>
        </div>
        <div className={LayoutStyle.loginAuthContent}>
          <div>
            <div className={PagesStyle.centerContainer}>
              <div className={LayoutStyle.loginLogoContainer}>
                <img src={logo} alt="Company Logo" />
              </div>
            </div>

            {/* <h1 className="auth-title">{title}</h1> */}
            {subtitle && (
              <p className={authStyle.authContentGuide}>{subtitle}</p>
            )}

            {children}

            {footerLinks && (
              <div className={LayoutStyle.loginFooterLink}>
                {footerLinks.map((link, index) => (
                  <p key={index}>
                    {link.text}{" "}
                    <Link
                      to={link.link}
                      className={LayoutStyle.loginSignupLink}
                    >
                      {link.linkText}
                    </Link>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
